import {Component, OnInit} from '@angular/core';
import {Funcao} from "../../../../types/Funcao";
import {FuncaoService} from "../../../../services/funcao.service";
import {ActivatedRoute, Router} from "@angular/router";
import {ToastService} from '../../../../services/toast.service';
import {Modulo} from "../../../../types/Modulo.type";
import {PerfilService} from "../../perfil/perfil.service";
import {AcaoService} from "../../../../services/acao.service";
import { Acao } from '../../../../types/Acao.type';

@Component({
  selector: 'app-funcoes-form',
  templateUrl: './funcoes-form.component.html',
  styleUrl: './funcoes-form.component.css'
})
export class FuncoesFormComponent implements OnInit {

  carregandoModulos: boolean = false;
  modulos: any[] | undefined;
  moduloSelecionado!: any;
  funcao: Funcao = {} as Funcao;
  funcaoEnviada: boolean = false;
  acoes: Acao[] = []
  acoesSelecionadas : Acao[] = [];

  constructor(private funcaoService: FuncaoService, private activatedRoute: ActivatedRoute, private toastService: ToastService, private perfilService: PerfilService, private acaoService: AcaoService, private router: Router) {

  }

  ngOnInit(): void {
    let id = this.activatedRoute.snapshot.paramMap.get('id');

    this.carregandoModulos = true;

    this.perfilService.getPermissoes().subscribe({
      next: (data) => {
        this.modulos = data
        this.carregandoModulos = false;
      },
      error: (error) => {
        this.toastService.erro("Erro", "Erro ao buscar os módulos")
      }
    })

    if (id) {
      this.funcaoService.getFuncao(id).subscribe({
        next: (data) => {
          this.funcao = data;

          this.moduloSelecionado = this.funcao.idModulo

          this.carregaAcoes(this.funcao.idModulo);

        },
        error: (error) => {
          this.toastService.erro("Erro", "Erro ao buscar a função: " + error);
        }
      });
    }
  }

  carregaAcoes(idModulo: String){

    if(idModulo) {
      this.acaoService.getAcoes(idModulo).subscribe({
        next: (data) => {

          this.acoes = data;

          this.acoesSelecionadas = []

          this.funcao.acoes.forEach(acao => {
            this.acoesSelecionadas.push(this.acoes.filter(f => f.id == acao.id)[0])
          })
        },
        error: (error) => {
          this.toastService.erro("Erro", "Erro ao buscas as ações do módulo: " + error.error);
        }
      })
    }

  }

  salvar() {

    this.funcaoEnviada = true;

    if (this.funcaoEnviada && this.funcao.nome?.trim() && this.moduloSelecionado) {

      this.funcao.idModulo = this.moduloSelecionado;
      this.funcao.acoes = this.acoesSelecionadas;

      if (this.funcao.id) {
        this.funcaoService.putFuncao(this.funcao).subscribe({
          next: (data) => {
            this.toastService.sucesso("Atualização", "Atualização efetuada com sucesso.");

            this.router.navigate(['administracao', 'funcao']);
          },
          error: (error) => {
            this.toastService.erro("Erro", "Erro ao cadastrar: " + error.error);
            console.error(error.error)
          }
        })
      } else {
        this.funcaoService.postFuncao(this.funcao).subscribe({
          next: (data) => {
            this.toastService.sucesso("Cadastro", "Cadastro efetuado com sucesso.");
            this.router.navigate(['administracao', 'funcao']);
          },
          error: (error) => {
            this.toastService.erro("Erro", "Erro ao cadastrar: " + error.error);
            console.error(error.error)
          }
        })
      }
    }
  }
}
